import { useUserStore } from "shared/stores/user";
import { type PermissionKey } from "shared/types/permissions";

export type PermissionsProducts = "traditional" | "social" | "outreach";

export default class Permissions {
  filteredPermissions(product: PermissionsProducts): PermissionKey[] {
    let permissions: PermissionKey[] = [];

    if (product === "traditional") {
      permissions = useUserStore().currentUser.permissions;
    } else if (product === "social") {
      permissions = useUserStore().currentUser.social_permissions;
    } else if (product === "outreach") {
      permissions = useUserStore().currentUser.outreach_permissions;
    }

    return permissions;
  }

  has(
    permission: PermissionKey,
    product: PermissionsProducts = "traditional"
  ): boolean {
    if (this.isAdminUser() && !this.isCustomerView()) return true;

    return (
      useUserStore() && this.filteredPermissions(product)?.includes(permission)
    );
  }

  hasAll(permissions: PermissionKey[] = []): boolean {
    return permissions.every((permission) => this.has(permission));
  }

  hasAllFeatures(permissionKeys: PermissionKey[]): boolean {
    return this.hasAll(permissionKeys);
  }

  hasAny(
    permissions: PermissionKey[] = [],
    product: PermissionsProducts = "traditional"
  ): boolean {
    return permissions.some((permission) => this.has(permission, product));
  }

  hasAnyFeature(permissionKey: PermissionKey[]): boolean {
    return this.hasAny(permissionKey);
  }

  hasFeature(permissionKey: PermissionKey): boolean {
    return this.has(permissionKey);
  }

  isAdminUser(): boolean {
    return useUserStore().isAdminUser;
  }

  isCustomerView(): boolean {
    return useUserStore().customerViewEnabled;
  }
}
